import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const processDataProperty = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .requiredFinal()
      .meta({ format: 'camelCase' })
      .describe('Property name'),

    isArray: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether this is an array'),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Description'),

    sequence: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Display order'),

    dataTypeId: z.uuid().hidden().describe('Foreign key to ProcessDataType'),

    typeId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to ProcessDataType'),

    dataType: belongsTo('ProcessDataType'),

    type: references('ProcessDataType'),
  })
  .describe('A property on a process data type.')
  .as('ProcessDataProperty');

export { processDataProperty as processDataPropertySchema };
